import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form, Container } from "react-bootstrap";
import { loadQuest, saveQuest } from "../../lib/api/quest";
import { EmptyBlank } from "../../components/common";
import { QuestEditForm } from "../../components/quest/QuestEditForm";

const QuestEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [quest, setQuest] = useState();

  const requestLoadQuest = useCallback(async () => {
    const { data } = await loadQuest({ id: id });
    //console.log(data);
    setQuest(data);
  }, [id]);

  useEffect(() => {
    requestLoadQuest();
  }, [requestLoadQuest]);

  const handleSave = async ({ latitude, longitude, meter }) => {
    const position = {
      latitude: latitude,
      longitude: longitude,
    };
    const info = { ...quest.info, gpsMeter: meter };
    const building = { ...quest.building, position: position };
    await saveQuest({ id, info, building });
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div>
      <Container fluid="md">
        {quest ? (
          <QuestEditForm
            quest={quest}
            handleSave={handleSave}
            handleClose={handleClose}
          />
        ) : undefined}
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default QuestEdit;
